export class BaseClass<Props> {

  props: Props;

  constructor(props: Props) {
    this.props = props;
  }
}

export function dropProps<Props, ClassProps>(data: Props, props: ClassProps): Props {
  const keys = Object.keys(data);
  const object = {};
  keys.forEach(key => {
    if (key !== 'props') {
      object[key] = props[key];
    }
  });
  return object as Props;
}